<template>
  <div class="demo-modal">
    <step-indicator
      :steps="indicatorSteps"
      :current="currentStep"
      @click-step="stepChanged"
      :disabled="loadingDemoData || readyToStart"
    />
    <form @submit.prevent>
      <h3>{{ headerText }}</h3>
      <transition name="first">
        <div class="first" v-if="currentStep == 1">
          <p class="description text-small text-muted">
            {{ $t("demo.start-flow.step-1.description") }}
          </p>
          <custom-input
            ref="nameinput"
            v-model="demoForm.name"
            :inputType="'text'"
            :name="'name'"
            :label="$t('demo.start-flow.step-1.name')"
            :placeholder="$t('demo.start-flow.step-1.name-placeholder')"
            :focusInputField="true"
          />
          <custom-input
            v-model="demoForm.email"
            :inputType="'email'"
            :name="'email'"
            :label="'Email'"
            :placeholder="$t('demo.start-flow.step-1.email-placeholder')"
          />
          <checkbox class="terms" lightLabel :label="termsAndConditions" v-model="termsChecked" />
          <div class="actions">
            <!-- /// Maybe send email to backend here already? -->
            <button :disabled="!firstStepValid" type="submit" class="btn btn-primary" @click="stepChanged(2)">
              {{ $t("next") }}
            </button>
          </div>
        </div>
      </transition>

      <transition :name="midTransition">
        <div class="second" v-if="currentStep == 2">
          <p class="description text-small text-muted">
            {{ $t("demo.start-flow.step-2.description") }}
          </p>
          <radio-button
            lightLabel
            :listClasses="'radio-btns'"
            :label="$t('demo.start-flow.step-2.radio-label')"
            :options="eCommerceSolutions"
            v-model="selectedSolution"
          />
          <p class="description text-small">
            <span v-if="selectedSolution == 'shopify'" v-html="$t('demo.start-flow.step-2.shopify-description')">
            </span>
            <span v-else-if="selectedSolution == 'xml'" v-html="$t('demo.start-flow.step-2.xml-description')"> </span>
            <span v-else v-html="$t('demo.start-flow.step-2.other-description')"> </span>
          </p>
          <custom-input
            v-model="demoForm.shopUrl"
            :isDisabled="selectedSolution == 'other'"
            :inputType="'text'"
            :name="'shopurl'"
            :label="'Webshop url'"
            :placeholder="$t('demo.start-flow.step-2.url-placeholder')"
            :invalidInput="urlInvalid"
            @input="testUrlDebounce(demoForm.shopUrl)"
          />
          <span v-show="testingUrl" class="text-small text-muted"
            ><i class="fa-light fa-circle-notch fa-spin"></i> {{ $t("demo.start-flow.step-2.url-check-loading") }}
          </span>
          <span v-if="urlOk" class="text-small text-success">{{ $t("demo.start-flow.step-2.url-check-ok") }}</span>
          <span v-else-if="urlInvalid" class="text-small text-danger"> {{ urlInvalidMsg }}</span>

          <div class="form-group select-standard-template">
            <label :class="{ hidelabel: !demoForm.standardTemplateId }" for="standardTemplateInput">{{$t('category')}}</label>
            <select
              :class="{ empty: !demoForm.standardTemplateId }"
              class="form-control selector"
              id="standardTemplateInput"
              v-model="demoForm.standardTemplateId"
            >
              <option v-for="(option, index) in standardTemplates" :key="index" :value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>

          <div class="actions">
            <button :disabled="!secondStepValid" type="submit" class="btn btn-primary" @click="getData()">
              {{ $t("demo.start-flow.step-2.next") }}
            </button>
          </div>
        </div>
      </transition>

      <transition name="last">
        <div class="third" v-if="currentStep == 3">
          <div v-if="loadingDemoData">
            <p class="description text-muted">
              <span>
                {{ loadingDataMsg }}
              </span>
              <span>
                <i class="fa-light fa-circle-notch fa-spin"></i>
              </span>
            </p>
            <p v-if="slowConnection" class=" text-small text-muted">
              {{ $t("demo.start-flow.step-3.slow-loading") }}
            </p>
          </div>
          <div v-else>
            <div v-if="loadingError" class="loading-error">
              <p class="description text-danger">
                {{ invalidMsg }}
              </p>
            </div>
            <!-- <div v-else>
              <p class=" text-muted text-small">
                {{$t('demo.start-flow.step-3.ready-description')}}
              </p>

              <ul class="rules-list">
                <li v-html="$t('demo.start-flow.step-3.rule-1')"></li>
                <li v-html="$t('demo.start-flow.step-3.rule-2')"></li>
                <li v-html="$t('demo.start-flow.step-3.rule-3')"></li>
                <li v-html="$t('demo.start-flow.step-3.rule-4')"></li>
              </ul>
            </div> -->
          </div>
          <div class="actions">
            <button
              :disabled="loadingError || loadingDemoData"
              type="submit"
              class="btn btn-primary"
              @click="startDemo()"
            >
              {{ $t("demo.start-flow.step-3.start") }}
            </button>
            <button v-if="loadingError" type="button" class="btn btn-primary btn-invert" @click="getData()">
              {{ $t("demo.start-flow.step-3.retry") }}
            </button>
          </div>
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
import { stepIndicatorMixin } from "@/assets/js/stepIndicatorMixin.js";
import RadioButton from "@/components/RadioButton";
import Checkbox from "@/components/Checkbox.vue";
import StepIndicator from "@/components/StepIndicator.vue";
import debounce from "lodash/debounce";
import appHelper from "@/assets/js/appHelper.js";
import demoHelper from "@/assets/js/demoHelper.js";
export default {
  name: "StartDemoModal",
  mixins: [stepIndicatorMixin],
  components: {
    RadioButton,
    Checkbox,
    StepIndicator
  },
  data() {
    return {
      headerText: this.$t("demo.start-flow.base-header"),
      testingUrl: false,
      loadingError: null,
      slowConnection: false,
      invalidMsg: "",
      urlInvalidMsg: "",
      urlInvalid: false,
      urlOk: false,
      loadingDemoData: false,
      readyToStart: false,
      midTransition: "mid-next",
      demoForm: {
        name: "",
        email: "",
        shopUrl: "",
        solution: "",
        standardTemplateId: null
      },
      termsChecked: false,
      eCommerceSolutions: [
        {
          value: "shopify",
          name: "shopify",
          label: "Shopify"
        },
        // {
        //   value: "xml",
        //   name: "xml",
        //   label: "Google shopping"
        // },
        {
          value: "other",
          name: "other",
          label: this.$t("demo.start-flow.step-2.other")
        }
      ],
      currentStep: 1,
      indicatorSteps: [
        {
          step: 1,
          title: this.$t("demo.start-flow.user-info"),
          allowed: true,
          visited: true,
          valid: false,
          disabled: false
        },
        {
          step: 2,
          title: this.$t("demo.start-flow.shop-info"),
          allowed: false,
          deniedAccessMsg: this.$t("demo.start-flow.basic-deny-access"),
          visited: false,
          valid: false,
          disabled: false
        },
        {
          step: 3,
          title: "Start demo",
          allowed: false,
          deniedAccessMsg: this.$t("demo.start-flow.basic-deny-access"),
          visited: false,
          valid: false,
          disabled: false
        }
      ],
      testUrlDebounce: debounce((url) => this.testUrl(url), 500),
      termsAndConditions: this.$t("demo.start-flow.step-1.terms"),
      standardTemplates: [],
      selectedSolution: "shopify",
    };
  },
  props: {
    onSubmit: Function
  },
  methods: {
    getStandardTemplates(solution) {
      this.standardTemplates = demoHelper.getStandardTemplates(appHelper.isProduction(), solution);
      this.demoForm.standardTemplateId = this.standardTemplates[0].id;
    },

    testUrl(url) {
      this.testingUrl = true;
      this.urlInvalid = false;
      this.urlOk = false;
      const shopData = {
        solution: this.selectedSolution,
        shopUrl: url
      };
      this.$store
        .dispatch("testDemoUrl", shopData)
        .then((res) => {
          this.testingUrl = false;
          this.urlInvalid = false;
          this.urlOk = true;
        })
        .catch((e) => {
          this.testingUrl = false;
          this.urlInvalid = true;
          this.urlInvalidMsg = e.body.Message;
        });
    },
    startDemo() {
      this.onSubmit();
      this.$emit("close");
    },

    stepChanged(to) {
      this.midTransition = this.nextTransition(this.currentStep, to);
      this.$nextTick(() => {
        this.currentStep = to;
      });
    },

    getData() {
      // combine solution and topic/standardTemplateid to get the correct definition in backend
      this.demoForm.solution = demoHelper.setDemoType(this.selectedSolution, this.standardTemplates.find((t) => t.id == this.demoForm.standardTemplateId));
      this.loadingError = false;
      this.stepChanged(3);
      setTimeout(() => {
        this.slowConnection = true;
      }, 4000);
      this.loadingDemoData = true;
      this.$store
        .dispatch("newDemoUser", this.demoForm)
        .then((res) => {
          this.indicatorSteps[2].valid = true;
          this.loadingDemoData = false;
          this.startDemoVersion = false;
          this.readyToStart = true;
          this.loadingError = false;
          this.headerText = this.$t("demo.start-flow.done-header");
          this.$store.dispatch("getDemoFavorites");
          this.startDemo();
        })
        .catch((e) => {
          this.loadingError = true;
          this.indicatorSteps[2].valid = false;
          this.startDemoVersion = false;
          this.loadingDemoData = false;
          if (e.status == 404) {
            this.invalidMsg = this.$t("demo.start-flow.step-3.404-error");
            this.stepChanged(2);
          } else {
            this.invalidMsg = this.$t("demo.start-flow.step-3.error");
          }
        });
    }
  },
  computed: {
    firstStepValid() {
      return this.demoForm.name && appHelper.emailRegex.test(this.demoForm.email) && this.termsChecked;
    },
    secondStepValid() {
      return this.demoForm.standardTemplateId && (this.selectedSolution != "other" ? this.urlOk : true);
    },
    loadingDataMsg() {
      return this.demoForm.solution == "other"
        ? this.$t("demo.start-flow.step-3.loading-other")
        : this.$t("demo.start-flow.step-3.loading-shop");
    }
  },
  watch: {
    selectedSolution: {
      handler: function() {
        this.demoForm.standardTemplateId = null;
        this.getStandardTemplates(this.selectedSolution)
      }
    },
    firstStepValid: {
      handler: function() {
        this.indicatorSteps[0].valid = this.firstStepValid;
        this.indicatorSteps[1].allowed = this.firstStepValid;
      },
      immediate: true
    },
    secondStepValid: {
      handler: function() {
        this.indicatorSteps[1].valid = this.secondStepValid;
        // this.indicatorSteps[2].allowed = this.secondStepValid;
      },
      immediate: true
    }
  },
  mounted() {
    this.$refs.nameinput.focus();
    this.getStandardTemplates(this.selectedSolution);
  }
};
</script>

<style lang="less">
.demo-modal {
  padding: 16px;
  .description {
    margin: 0;
  }
  .radio-btns-wrapper {
    padding-bottom: 0px;
  }
  .radio-btns {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;

    .radio-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      // margin-bottom: 0;
    }
  }
  .terms {
    margin-top: 12px;
    margin-bottom: 0;
    display: inline-block;
  }
  .actions {
    margin-top: 16px;
    display: flex;
    gap: 12px;
  }

  .loading-error {
    display: flex;
    gap: 2px;
    align-items: center;
  }
  .rules-list {
    padding: 0 0 0 16px;
    list-style-type: circle;
    li {
      margin-bottom: 8px;
    }
  }
  .second{
    position: relative;
  }
  .select-standard-template{
    margin-top: 16px;
  }
  .hidelabel {
    opacity: 0;
  }
}
</style>
